import { Tag } from 'antd';

export default function BetaTag(): JSX.Element {
	return (
		<Tag bordered={false} color="geekblue">
			Beta
		</Tag>
	);
}
